<template>
  <div class="col-12 relative grey-bg">
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <CategoryHeader :reference="route.meta.reference" :icon="route.meta.icon" />
      <ActionButton v-for="(action, actionIndex) in items" :key="actionIndex" :reference="action.reference" :pathname="action.pathName" :path="action.path" />
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import ActionButton from '@/components/elements/ActionButton';
import CategoryHeader from '@/components/common/CategoryHeader';

import { menuHandler, routeIsCurrentComponent} from '@/mixins/utils';

export default {
  components: {
    ActionButton,
    CategoryHeader
  },
  setup () {
    const route = useRoute();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const items = computed(() => menuHandler(route.name));
    return { items, route, routeMatchesComponent };
  }
};
</script>

<style lang="scss">
</style>
